<template>
  <b-modal
    id="admin-stammdaten-onboarding-modal"
    v-model="localShow"
    title="Willkommen in der Stammdatenverwaltung"
    size="lg"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    @hide="onHide"
  >
    <div class="admin-onboarding">
      <p class="admin-onboarding-intro">
        In der Stammdatenverwaltung pflegen Sie die zentralen Angaben Ihrer Gemeinde.
        Diese Daten werden im OZG Manager an mehreren Stellen weiterverwendet.
      </p>

      <b-alert show variant="warning" class="mb-3">
        Wenn Stammdaten fehlen oder falsch gepflegt sind, können nachgelagerte Funktionen
        fehlerhaft arbeiten. Das betrifft zum Beispiel Ansprechpartner in Formularen,
        Empfängeradressen, rechtliche Angaben oder Zahlungsfunktionen.
      </b-alert>

      <p v-if="helpLink" class="admin-onboarding-help-link">
        Weitere Informationen finden Sie in der
        <a
          :href="helpLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          Anleitung zur Stammdatenverwaltung
        </a>.
      </p>

      <h6>Wichtige Bereiche</h6>

      <ul class="admin-onboarding-list">
        <li>
          <strong>Allgemein:</strong>
          Basisdaten, kommunale Leitung, Wappen und Logo.
        </li>
        <li>
          <strong>Adressen:</strong>
          Hauptanschrift und weitere relevante Adressen der Gemeinde.
        </li>
        <li>
          <strong>Kommunikation:</strong>
          E-Mail-Adressen und Kontaktwege, die für Systemprozesse genutzt werden können.
        </li>
        <li>
          <strong>Mitarbeiter:</strong>
          Ansprechpartner, die später in Formularen angezeigt oder verwendet werden können.
        </li>
        <li>
          <strong>Datenschutz, Impressum und Barrierefreiheit:</strong>
          Rechtliche Pflichtangaben für das digitale Rathaus.
        </li>
        <li>
          <strong>Bezahldienste, Gebühren und Kosten:</strong>
          Angaben für kostenpflichtige Leistungen und Zahlungsprozesse.
        </li>
      </ul>

      <div class="admin-onboarding-note">
        Prüfen Sie die Angaben sorgfältig und speichern Sie Änderungen unten über
        <strong>Speichern</strong>.
      </div>

      <b-form-checkbox v-model="doNotShowAgain" class="mt-3">
        Diesen Hinweis nicht mehr anzeigen
      </b-form-checkbox>
    </div>

    <template #modal-footer>
      <b-button variant="secondary" @click="remindLater">
        Später erinnern
      </b-button>

      <b-button variant="primary" @click="finishOnboarding">
        Verstanden, Stammdaten pflegen
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "AdminStammdatenOnboardingModal",

  props: {
    show: {
      type: Boolean,
      default: false
    },

    helpLink: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      localShow: this.show,
      doNotShowAgain: false
    };
  },

  watch: {
    show(value) {
      this.localShow = value;
    },

    localShow(value) {
      this.$emit("update:show", value);
    }
  },

  methods: {
    finishOnboarding() {
      this.$emit("completed", {
        doNotShowAgain: this.doNotShowAgain
      });

      this.localShow = false;
    },

    remindLater() {
      this.$emit("remind-later");
      this.localShow = false;
    },

    onHide() {
      this.$emit("update:show", false);
    }
  }
};
</script>

<style scoped>
.admin-onboarding {
  font-size: 14px;
  line-height: 1.55;
}

.admin-onboarding-intro {
  margin-bottom: 14px;
}

.admin-onboarding-help-link {
  margin-bottom: 14px;
}

.admin-onboarding-help-link a {
  color: #0069b4;
  font-weight: 600;
  text-decoration: underline;
}

.admin-onboarding-help-link a:hover {
  color: #004f87;
  text-decoration: none;
}

.admin-onboarding-list {
  padding-left: 20px;
  margin-bottom: 14px;
}

.admin-onboarding-list li {
  margin-bottom: 8px;
}

.admin-onboarding-note {
  background: #f7f7f7;
  border-left: 4px solid #0069b4;
  padding: 10px 12px;
  margin-top: 12px;
}
</style>